module.exports = __webpack_public_path__ + "1705aca5c5f3b1348c14da279ea1beb6.mp4";


//////////////////
// WEBPACK FOOTER
// ./app/assets/video/campaign_nl.mp4
// module id = 941
// module chunks = 4